<template>
    <div>

    </div>
</template>

<script>
    export default {
        name: "StatAction",
        methods: {
        }
    }
</script>

<style scoped>

</style>